/* eslint-disable no-irregular-whitespace */

import { Clear, NotificationsOutlined } from '@mui/icons-material';
// import CheckIcon from '@mui/icons-material/Check';
// import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import {
    Badge,
    Box,
    IconButton,
    Menu,
    MenuItem,
} from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import { useNotificationCenter } from 'react-toastify/addons/use-notification-center';
// const types = ['success', 'info', 'warning', 'error'];
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
// import { SocketTest } from '../../../SocketTest';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
// const useStyles = makeStyles(() => ({
//     button: {
//         marginRight: '12px',
//     },
//     unread: {
//         fontWeight: 'bold',
//     },
//     menu: {
//         minWidth: 350,
//     },
//     menuItem: {
//         '&$unread': {
//             backgroundColor: '#f4f4ff',
//             // color: theme.palette.primary.contrastText,
//         },
//     },
// }));

// * 4 List
// const useStyles = makeStyles(() => ({
//     root: {
//         backgroundColor: '#f4f4ff',
//         position: 'absolute',
//         top: '64px',
//         right: '16px',
//         zIndex: '999',
//         width: '300px',
//         height: '400px',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'flex-start',
//         borderRadius: '20px'
//         // overflow: 'scroll'
//     },
//     iconButton: {
//         position: 'absolute',
//         top: '24px',
//         right: '24px',
//         zIndex: '1000',
//     },
//     unread: {
//         fontWeight: '900 !important',
//         backgroundColor: 'white',
//     },
// }));
const REFRESH_NOTIF_TIME = 50 * 6; //  to not have a lot of update in dev env : 50s * 6

export function NotificationBarUsingMenu() {
    NotificationBarUsingMenu.propTypes = {
        notifications: PropTypes.array,
        setNotifications: PropTypes.func,
        anchorEl: PropTypes.any,
        setAnchorEl: PropTypes.func,
    };
    const { pathname } = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);

    const [notifications, setNotifications] = useState([]);
    const [count, setCount] = useState(0);

    useEffect(() => {
        let intervalId = null;
        if (count > 0) {
            intervalId = setInterval(() => {
                // console.log(count);
                setCount(count - 1);
            }, 1000);
        } else {
            getMyNotification();
            setCount(REFRESH_NOTIF_TIME);
            console.log(`This will run after ${REFRESH_NOTIF_TIME} seconds!`);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [count]);

    // const {data: notifications , refresh} = useGetRequest({url: '/notification/getMyNotification'});

    const getMyNotification = async () => {
        const response = await axiosPrivate.get('/notification/getMyNotification');
        if (Array.isArray(response?.data))
            setNotifications(response?.data.reverse());
    };
    const unreadCount = useMemo(() => notifications.reduce((acc, notification) => {
        return !notification.isViewed ? acc + 1 : acc;
    }, 0), [notifications]);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const makeNotifAsRead = async (notificationId) => {
        const response = await axiosPrivate.post(`/notification/modifyNotification/${notificationId}`, {
            'isViewed': true
        });
        if (response) {
            getMyNotification();
        }
    };
    const deleteNotification = async (notificationId) => {
        const response = await axiosPrivate.delete(`/notification/deleteNotification/${notificationId}`);
        if (response) {
            getMyNotification();
        }
    };
    const getTheNotifRoute = (notifRoute) => {
        const urlArray = pathname.split('/');
        const firstTwoElements = urlArray.slice(0, 1);
        const newUrl = firstTwoElements.join('/') + notifRoute;
        return newUrl;
    };
    const extractVariablesAndSplitMessage = (message) => {
        const regex = /"([^"]*?)"/g;
        const parts = message.split(regex);
        const result = [];
        parts.forEach((part) => {
            // Vérifier si le segment contient un texte entouré de guillemets
            // if (part.startsWith('"') && part.endsWith('"')) {
            //     result.push(part); // Garder tel quel
            // } else {
            //     result.push(i18n.t(part));
            // }
            // Skip translation if part is a time format (e.g., "HH:mm")
            if (/^\d{1,2}:\d{2}$/.test(part)) {
                result.push(part); // Keep it as-is
            } else {
                result.push(i18n.t(part)); // Translate other parts
            }
        });
        // console.log({ maa: result.filter(part => part.trim() !== '') });
        return result.filter(part => part.trim() !== '').join('');
    };

    return (
        // * GOOD Ui/UX https://dribbble.com/shots/17020453-Notifications/attachments/12102501?mode=media
        <>
            <a
                onClick={handleMenuOpen}
                aria-label="first page"
            >
                <Badge
                    color="error"
                    badgeContent={unreadCount}
                    max={99}
                >
                    <NotificationsOutlined style={{ color: '#272D3C' }} />
                </Badge>
            </a>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{ sx: { borderRadius: '16px', maxHeight: '383px', width: '383px', overflowY: 'auto' } }}
                sx={{ borderRadius: '16px' }}
            >
                {notifications.map((notification) => (
                    <MenuItem
                        key={notification._id}
                        onClick={() => makeNotifAsRead(notification._id)}
                        style={{ display: 'flex', gap: '4px', borderBottom: '1px solid #E7EAF9', flexDirection: 'column', alignItems: 'flex-start' }}
                    >
                        {/* <img src='https://images.unsplash.com/photo-1566275529824-cca6d008f3da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8cGhvdG98ZW58MHx8MHx8&w=1000&q=80'/> */}
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'flex-start', alignSelf: 'stretch' }}>
                            <Badge
                                color="primary"
                                style={{ padding: '3px' }}
                            >
                                <Box
                                    component="span"
                                    sx={{ bgcolor: notification?.isViewed ? '#97989c' : '#72C040', width: 10, height: 10, borderRadius: '50%' }}
                                />
                            </Badge>
                            <p className='notifdate'>{formatDateJJMMYYYY(notification?.createdAt.toLocaleString())}</p>
                        </div>
                        <p className={notification.isViewed ? 'notifRead' : 'notifUnread'}>
                            {notification?.route ?
                                <Link to={getTheNotifRoute(notification?.route)}>{extractVariablesAndSplitMessage(notification?.message)}</Link>
                                :
                                extractVariablesAndSplitMessage(notification?.message)
                            }
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '12px', alignSelf: 'stretch' }}>
                            <IconButton
                                onClick={() => {
                                    deleteNotification(notification._id);
                                }}
                            >
                                <Clear />
                            </IconButton>
                        </div>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

// export function NotificationBarUsingList({ notifications, setNotifications,  }) {
//     NotificationBarUsingList.propTypes = {
//         notifications: PropTypes.array,
//         setNotifications: PropTypes.func,
//         showPanel: PropTypes.any,
//         setShowPanel: PropTypes.func,
//     };
//     const classes = useStyles();
//     const [showPanel, setShowPanel] = useState(false);

//     return (
//         <>
//             <a
//                 onClick={ () => {
//                     setShowPanel(!showPanel);
//                 }}
//                 aria-label="first page"
//             >
//                 <Badge
//                     color="secondary"
//                     badgeContent={notifications.length}
//                     max={99}
//                 >
//                     <NotificationsOutlined style={{ color: '#272D3C' }} />
//                 </Badge>
//             </a>
//             <div
//                 className={classes.root}
//                 hidden={showPanel}
//             >
//                 <List>
//                     {notifications.map((notification) => (
//                         <ListItem
//                             key={notification?._id}
//                         // button
//                         >
//                             <ListItemText
//                                 primary={notification?.message}
//                                 secondary={formatDateJJMMYYYY(notification?.createdAt.toLocaleString())}
//                                 className={notification.isViewed ? 'notifRead' : 'notifUnread'}
//                                 // className={notification.isViewed ? null : classes.unread}
//                                 // sx={notification.isViewed ? null : {fontWeight: 'bold'}}

//                             />
//                         </ListItem>
//                     ))}
//                 </List>
//                 {/* //! if you wan't this work, you must restart the backend server after every http request ( even refresh) */}
//                 <SocketTest setNotifications={setNotifications} />
//             </div>
//         </>
//     );
// }

// export default function NotificationBar({ notifications }) {
//     NotificationBar.propTypes = {
//         notifications: PropTypes.array,
//         setNotifications: PropTypes.func,
//     };

//     // const {
//     //     notifications,
//     //     clear,
//     //     markAllAsRead,
//     //     markAsRead,
//     const unreadCount = notifications.reduce((acc, notification) => {
//         return notification.isViewed ? acc + 1 : acc;
//     }, 0);

//     // } = useNotificationCenter();
//     const [showUnreadOnly, setShowUnreadOnly] = useState(false);
//     const [isOpen, setIsOpen] = useState(false);
//     const [anchorEl, setAnchorEl] = useState(null);

//     const toggleNotificationCenter = (event) => {
//         setAnchorEl(event.currentTarget);
//         setIsOpen(!isOpen);
//     };

//     const toggleFilter = () => {
//         setShowUnreadOnly(!showUnreadOnly);
//     };

//     return (
//         <Box >
//             {/* sx={{ margin: '8px' }} */}
//             <a
//                 onClick={toggleNotificationCenter}
//                 aria-label="first page"
//             >
//                 <Badge
//                     color="secondary"
//                     badgeContent={notifications.length}
//                     max={99}
//                 >
//                     <NotificationsOutlined style={{ color: '#272D3C' }} />
//                 </Badge>
//             </a>
//             {/* <IconButton
//                 size="large"
//                 onClick={toggleNotificationCenter}
//             >
//                 <Badge
//                     badgeContent={notifications.length}
//                     color="primary"
//                 >
//                     <NotificationsOutlined color="action" />
//                 </Badge>
//             </IconButton> */}

//             <Popper
//                 open={isOpen}
//                 anchorEl={anchorEl}
//                 transition
//             >
//                 {({ TransitionProps }) => (
//                     <Fade
//                         {...TransitionProps}
//                         timeout={350}
//                     >
//                         <Box>
//                             <Box
//                                 sx={{
//                                     background: '#666',
//                                     padding: '8px',
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center'
//                                 }}
//                             >
//                                 <Typography
//                                     variant="h5"
//                                     color="#fff"
//                                 >
//                                     Centre des notifications
//                                 </Typography>
//                                 <FormGroup sx={{ color: '#fff' }}>
//                                     <FormControlLabel
//                                         control={
//                                             <Switch
//                                                 color="secondary"
//                                                 onChange={toggleFilter}
//                                                 checked={showUnreadOnly}
//                                             />
//                                         }
//                                         label="Afficher uniquement les non lus"
//                                     />
//                                 </FormGroup>
//                             </Box>
//                             <Stack
//                                 sx={{
//                                     height: '400px',
//                                     width: 'min(60ch, 100ch)',
//                                     padding: '12px',
//                                     background: '#f1f1f1',
//                                     borderRadius: '8px',
//                                     overflowY: 'auto'
//                                 }}
//                                 spacing={2}
//                             >
//                                 {(!notifications.length ||
//                                     (unreadCount === 0 && showUnreadOnly)) && (
//                                     <h4>
//                                         {/* Your queue is empty! you are all set{' '} */}
//                                         {'Votre file d\'attente est vide ! Vous êtes prêt '}
//                                         <span
//                                             role="img"
//                                             aria-label="dunno what to put"
//                                         >
//                                                 🎉
//                                         </span>
//                                     </h4>
//                                 )}
//                                 {(showUnreadOnly
//                                     ? notifications.filter((v) => !v?.isViewed)
//                                     : notifications
//                                 ).map((notification) => {
//                                     return (
//                                         <Alert
//                                             key={notification?._id}
//                                             severity={(notification.type) || 'info'}
//                                             action={
//                                                 notification?.isViewed ? (
//                                                     <CheckIcon />
//                                                 ) : (
//                                                     <IconButton
//                                                         color="primary"
//                                                         aria-label="upload picture"
//                                                         component="span"
//                                                     // onClick={() => markAsRead(notification.id)}
//                                                     >
//                                                         <MarkChatReadIcon />
//                                                     </IconButton>
//                                                 )
//                                             }
//                                         >
//                                             {notification?.message}
//                                             {formatDateJJMMYYYY(notification?.createdAt.toLocaleString())}
//                                         </Alert>
//                                     );
//                                 })}
//                             </Stack>
//                             <Box
//                                 sx={{
//                                     background: '#666',
//                                     padding: '8px',
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center'
//                                 }}
//                             >
//                                 <Button
//                                     variant="contained"
//                                 // onClick={clear}
//                                 >
//                                     Clear All
//                                 </Button>

//                                 <Button
//                                     variant="contained"
//                                 // onClick={markAllAsRead}
//                                 >
//                                     Mark all as read
//                                 </Button>
//                             </Box>
//                         </Box>
//                     </Fade>
//                 )}
//             </Popper>
//         </Box>
//     );
// }
